import classNames from "classnames";
import styles from "./index.module.less";
import { useMemo } from "react";
const Navs = ({
  anchors,
  active,
  onClick
}: {
  anchors?: string[];
  active?: string;
  onClick?: (anchor: string) => void;
}) => {
  const isFirstThree = useMemo(() => {
    if (!active || !anchors) return false;
    const index = anchors.findIndex((anchor) => anchor === active);
    return index >= 0 && index < 3;
  }, [active, anchors]);
  const isLastThree = useMemo(() => {
    if (!active || !anchors) return false;
    const index = anchors.findIndex((anchor) => anchor === active);
    return index >= 0 && index >= anchors.length - 3;
  }, [active, anchors]);
  return (
    <div className={styles.navs}>
      <div className={styles.activeNav}>{active}</div>
      <div className={classNames(styles.navList, { [styles.firstThree]: isFirstThree, [styles.lastThree]: isLastThree })}>
        {anchors?.map((anchor) => (
          <a
            key={anchor}
            onClick={() => {
              onClick?.(anchor);
              // const element = document.getElementById(`solution-${anchor}`);
              // if (element) {
              //   element.scrollIntoView({ behavior: "smooth", block: "center" });
              // }
            }}
            className={classNames(styles.nav, {
              [styles.active]: active === anchor,
            })}
            id={`nav-${anchor}`}
          >
            {anchor}
          </a>
        ))}
      </div>
    </div>
  );
};
export default Navs;
